const axios = require('axios')
const jsCookie = require('js-cookie')
const queryString = require('query-string')

const $ajax= axios.create({
    withCredentials:true
});

const user = {
    id: jsCookie.get('id') || ''
}

// just check cookie
function ensureLogin() {
    if (user.id) {
        return true
    } else {
        reject()
        clearCookie()
        toLogin()
    }
}

function toLogin(link = location.href) {
    console.log('login')
    location.href = `//open.haiziwang.com/auth/login?link=${encodeURIComponent(link)}`
}

function toPortalHome() {
    location.href = `//open.haiziwang.com`
}

/**
 * 专为b端门户校验登陆态并获取用户信息（此时获取到的不一定是商家状态，可能还不是商家）
 */
// real check, will write cookie
function checkLogin() {
    return new Promise(async (resolve, reject) => {
        if (user.id) {
            const param = JSON.stringify({
                id:user.id
            })
            const res = await $ajax.post(`//portal.haiziwang.com/portal-api/account/queryAccountInfoNeedLogin.do`, queryString.stringify({ param }))
            const json = res.data
            if (json.code * 1 === 1) {
                setCookie(json.data)
                resolve(json.data)
            } else if (json.code * 1 === 3) {
                clearCookie()
                toLogin()
            } else {
                console.log('some error occur when portal.haiziwang.com/portal-api/account/queryAccountInfoNeedLogin.do')
            }
            reject()
        } else {
            reject()
            clearCookie()
            toLogin()
        }
    })
}

async function checkLogin4POPPlatform(cb) {
    const token = jsCookie.get('siteToken')
    if (token) {
        const res = await $ajax.get(`//seller.haiziwang.com/popAuthApi/checkLogin.do`, {
            params: { token }
        })
        const json = res.data || {}
        if (json.code * 1 === 1) {
            return json.data
        } else if (json.code * 1 === 5005) {
            cb && cb()
            toLogin()
        } else {
            return json
        }
    } else {
        cb && cb()
        toLogin()
    }
}



function setCookie(data) {
    if(data.buzzId) jsCookie.set('buzzId', data.buzzId);
    if(data.buzzType) jsCookie.set('buzzType', data.buzzType);
    if(data.buzzCode) jsCookie.set('buzzCode', data.buzzCode);
}

function clearCookie() {
    if (jsCookie.get()) {
        Object.keys(jsCookie.get()).forEach(function(cookieName) {
            jsCookie.remove(cookieName, { domain: '.haiziwang.com' });
        });
    }
}


function hasCookie (name) {
    return !!(name && jsCookie.get(name))
}

/**
 * 获取cookie
 * @param name {string}
 * @returns {*}
 */
function getCookie (name) {
    return jsCookie.get(name)
}

module.exports = {
    getCookie,
    toPortalHome,
    ensureLogin,
    toLogin,
    clearCookie,
    checkLogin,
    checkLogin4POPPlatform
}
